<label class="mat-optgroup-label" [id]="_labelId">{{ label }}</label><ng-content select="mat-option, ng-container"></ng-content>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/core/typings/index.d.ts.MatOptgroup.html